<template>
  <ClientOnly>
    <div class="search-container container-xl px-3 px-xl-3 col-md-9 col-xl-12 mt-3 mt-lg-0">
      <div class="search-bar col-xl-11 mx-auto">
        <div
          class="search-bar-head d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-md-center">
          <h2 class="fsz-18 fw-Bold">Trouvez votre voiture</h2>
          <div :class="width < breakpoints.screen_mobile && 'w-100'"
            class="d-flex justify-content-between gap-4 align-items-center">
            <span class="me-auto fsz-14 fw-normal text-gray-500 d-flex align-items-center">
              <i class="material-icons-outlined fsz-18 me-1">place</i>
              <span v-if="city">{{ city }}</span>
              <span v-else>Toute la Tunisie</span>
            </span>

            <div class="position-relative">
              <label v-if="!isMobileCitySelector" for="adress"
                class="btn fsz-14 fw-normal p-0 btn-border-hidden text-primary">
                Sélectionner
                <div class="position-absolute multi-select-hidden translate-middle city-selector-anchor">
                  <MultiSelect :ref="(el) => (element['citys'] = el)" inputId="adress" class="w-100"
                    v-model="searchStore.selectedInput.cities" :options="cities" optionLabel="name" optionValue="name"
                    :filter="true" filterPlaceholder="Rechercher une adresse..." :placeholder="'Tout les villes'">
                    <template #footer>
                      <div class="p-3 d-flex gap-2 justify-content-between border-top">
                        <button :disabled="searchStore.getPendingStats.announceCountPending"
                          @click="searchValues.cities = [], searchStore.selectedInput.cities = searchValues.cities, searchStore.searchCount()"
                          class="btn btn-solid-gray-400 small-btn w-100">
                          Effacer
                        </button>
                        <button
                          @click="searchStore.selectedInput.cities = searchValues.cities, searchStore.searchCount(), toggle($event, 'citys')"
                          class="btn btn-solid-primary-600 small-btn w-100">
                          <div v-if="searchStore.getPendingStats.announceCountPending"
                            :disabled="searchStore.getPendingStats.announceCountPending"
                            class="spinner-border text-white" role="status"></div>
                          Appliquer
                        </button>
                      </div>
                    </template>
                  </MultiSelect>
                </div>
              </label>
              <button v-else type="button" class="btn fsz-14 fw-normal p-0 btn-border-hidden text-primary"
                @click="openMobileSheet('city')">
                Sélectionner
              </button>
            </div>
          </div>
        </div>

        <div class="search-bar-body row input-group m-0 g-3 justify-content-between">
          <div class="col-lg-6 col-xl-3 p-0 pt-lg-0 pb-lg-0">
            <div class="p-float-label multi-select-simple">
              <template v-if="!isMobileCitySelector">
                <MultiSelect appendTo="self" inputId="makes-multiselect" class="w-100"
                  :ref="(el) => (element['mark'] = el)" v-model="searchValues.makes" :options="searchStore.getMakes"
                  optionLabel="name" :filter="true" :showToggleAll="false" filterPlaceholder="Rechercher une marque...">
                  <template #footer>
                    <div class="p-3 d-flex gap-2 justify-content-between border-top">
                      <button
                        @click="searchValues.makes = [], searchValues.models = [], searchStore.selectedInput.makes = searchValues.makes, searchStore.searchCount()"
                        class="btn btn-solid-gray-400 small-btn w-100">
                        Effacer
                      </button>
                      <button :disabled="searchStore.getPendingStats.announceCountPending"
                        @click="searchStore.selectedInput.makes = searchValues.makes, searchStore.searchCount(), getUserMakesId(), toggle($event, 'mark')"
                        class="btn btn-solid-primary-600 small-btn w-100">
                        <div v-if="searchStore.getPendingStats.announceCountPending" class="spinner-border text-white"
                          role="status"></div>
                        Appliquer
                      </button>
                    </div>
                  </template>
                </MultiSelect>
                <label for="makes-multiselect">Toutes les marques</label>
              </template>
              <template v-else>
                <button type="button" class="mobile-select-trigger" @click="openMobileSheet('makes')">
                  <span :class="makesSummary ? 'mobile-select-trigger__value' : 'mobile-select-trigger__placeholder'">
                    {{ makesSummary || 'Toutes les marques' }}
                  </span>
                  <i class="material-icons-outlined text-gray-500 fsz-18">keyboard_arrow_down</i>
                </button>
              </template>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 p-0 ps-lg-3 pt-3 pt-lg-0 pb-xl-0 pt-xl-0">
            <div class="p-float-label multi-select-simple">
              <template v-if="!isMobileCitySelector">
                <MultiSelect appendTo="self" inputId="models-multiselect" :ref="(el) => (element['model'] = el)"
                  class="w-100" v-model="searchValues.models" :options="searchStore.getModels" optionLabel="name"
                  :optionGroupLabel="searchStore.getModels && searchStore.getModels[0]?.make ? 'make' : ''"
                  :optionGroupChildren="searchStore.getModels && searchStore.getModels[0]?.make ? 'models' : ''"
                  :showToggleAll="false" :filter="true"
                  :disabled="searchStore.getModels && !searchStore.getModels.length || (searchValues.makes && !searchValues.makes.length)"
                  filterPlaceholder="Rechercher un modèle...">
                  <template #footer>
                    <div class="p-3 d-flex gap-2 justify-content-between border-top">
                      <button
                        @click="searchValues.models = [], searchStore.selectedInput.models = searchValues.models, searchStore.searchCount()"
                        class="btn btn-solid-gray-400 small-btn w-100">
                        Effacer
                      </button>
                      <button :disabled="searchStore.getPendingStats.announceCountPending"
                        @click="searchStore.selectedInput.models = searchValues.models, searchStore.searchCount(), toggle($event, 'model')"
                        class="btn btn-solid-primary-600 small-btn w-100">
                        <div v-if="searchStore.getPendingStats.announceCountPending" class="spinner-border text-white"
                          role="status"></div>
                        Appliquer
                      </button>
                    </div>
                  </template>
                </MultiSelect>
                <label for="models-multiselect">Tous les modèles</label>
              </template>
              <template v-else>
                <button type="button" class="mobile-select-trigger"
                  :disabled="searchStore.getModels && !searchStore.getModels.length || (searchValues.makes && !searchValues.makes.length)"
                  @click="openMobileSheet('models')">
                  <span :class="modelsSummary ? 'mobile-select-trigger__value' : 'mobile-select-trigger__placeholder'">
                    {{ modelsSummary || 'Tous les modèles' }}
                  </span>
                  <i class="material-icons-outlined text-gray-500 fsz-18">keyboard_arrow_down</i>
                </button>
              </template>
            </div>
          </div>

          <div class="col-xl-2 col-lg-6 col-sm-6 p-0 pe-sm-3 pe-lg-0 ps-xl-3 pt-3 pt-xl-0">
            <div class="simple-input">
              <span class="p-float-label p-input-icon-left w-100">
                <i class="material-icons-outlined fsz-18">paid</i>
                <InputNumber inputId="max-price-input" :input-props="{ inputmode: 'numeric' }" class="w-100"
                  v-model="searchValues.maxPrice" mode="decimal" :useGrouping="false"
                  @Keyup="handleSearchInput($event, 'maxPrice')" />
                <label for="max-price-input">Prix max.</label>
              </span>
            </div>
          </div>

          <div class="col-xl-2 col-lg-3 col-sm-6 p-0 ps-lg-3 pt-3 pt-xl-0">
            <div class="simple-input">
              <span class="p-float-label p-input-icon-left w-100">
                <i class="material-icons-outlined fsz-18">speed</i>
                <InputNumber inputId="max-km-input" :input-props="{ inputmode: 'numeric' }" class="w-100"
                  v-model="searchValues.maxKilometers" mode="decimal" :useGrouping="false"
                  @Keyup="handleSearchInput($event, 'maxKlm')" />
                <label for="max-km-input">Km max.</label>
              </span>
            </div>
          </div>

          <div class="col-lg-3 col-xl-2 pe-xl-0 p-0 ps-lg-3 pt-3 pt-xl-0">
            <button @click="applySearch()" class="btn btn-solid-primary-600 medium-btn p-14 fsz-14 w-100">
              <div v-if="searchStore.getPendingStats.announceCountPending" class="spinner-border text-white"
                role="status">
              </div>
              <span v-else>
                {{ searchStore.getAnnounceCount ?? searchStore.getFetchResult?.totalCount ?? 0 }} résultats
              </span>
            </button>
          </div>
        </div>
      </div>

      <MobileOptionsSheet v-if="isMobileCitySelector" :visible="mobileSheetOpen.city"
        :model-value="searchValues.cities || []" :options="cities" optionLabel="name" optionValue="name"
        searchPlaceholder="Rechercher une adresse..." :pending="searchStore.getPendingStats.announceCountPending"
        @update:visible="(value) => setMobileSheetVisible('city', value)" @update:modelValue="applyMobileCities" />

      <MobileOptionsSheet v-if="isMobileCitySelector" :visible="mobileSheetOpen.makes"
        :model-value="searchValues.makes || []" :options="searchStore.getMakes" optionLabel="name"
        searchPlaceholder="Rechercher une marque..." :pending="searchStore.getPendingStats.announceCountPending"
        @update:visible="(value) => setMobileSheetVisible('makes', value)" @update:modelValue="applyMobileMakes" />

      <MobileOptionsSheet v-if="isMobileCitySelector" :visible="mobileSheetOpen.models"
        :model-value="searchValues.models || []" :options="searchStore.getModels" optionLabel="name"
        :optionGroupLabel="searchStore.getModels && searchStore.getModels[0]?.make ? 'make' : ''"
        :optionGroupChildren="searchStore.getModels && searchStore.getModels[0]?.make ? 'models' : ''"
        searchPlaceholder="Rechercher un modèle..." :pending="searchStore.getPendingStats.announceCountPending"
        @update:visible="(value) => setMobileSheetVisible('models', value)" @update:modelValue="applyMobileModels" />
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
import cities from "~/utils/tunisia_state.js";
import { useDebounceFn } from "@vueuse/core";
import {
  getDisplayedPromotedIds,
  getUniquePromotedAnnouncements,
} from "~/utils/promotedResults";

const dashStore = useDashboardStore();
const searchStore = useSearchStore();
const runTimeConfig = useRuntimeConfig();
const { width } = useWindowSize();

const isMobileCitySelector = computed(() => width.value < breakpoints.screen_mobile);

const {
  mobileSheetOpen,
  openMobileSheet,
  setMobileSheetVisible,
} = useMobileSheetState(["city", "makes", "models"] as const, {
  isEnabled: isMobileCitySelector,
});

let searchValues: UserSearchInput = reactive({} as UserSearchInput);

const city = computed(() => {
  searchValues.cities = searchStore.getSelectedInput.cities;

  if (searchValues.cities) {
    if (searchValues.cities.length <= 6) {
      return searchValues.cities.join(", ");
    }

    return `${searchValues.cities.at(0)}, +(${searchValues.cities.length - 1})`;
  }

  return "";
});

const formatArraySummary = (
  list: any[] | undefined,
  labelKey: string,
  fallback = ""
): string => {
  if (!Array.isArray(list) || list.length === 0) return fallback;
  const extractLabel = (entry: any) => {
    if (entry == null) return "";
    if (typeof entry === "object") return String(entry?.[labelKey] ?? "");
    return String(entry);
  };

  if (list.length === 1) return extractLabel(list[0]);
  return `${extractLabel(list[0])}, +(${list.length - 1})`;
};

const makesSummary = computed(() =>
  formatArraySummary(searchValues.makes as any[], "name")
);

const modelsSummary = computed(() =>
  formatArraySummary(searchValues.models as any[], "name")
);

const element: any = reactive({});

const toggle = (event: any, key: string) => {
  element[key].hide(event);
};

const applyMobileCities = async (nextValue: any[] | any | null) => {
  const citiesSelection = Array.isArray(nextValue) ? nextValue : [];
  searchValues.cities = [...citiesSelection];
  searchStore.selectedInput.cities = [...citiesSelection];
  await searchStore.searchCount();
};

const applyMobileMakes = async (nextValue: any[] | any | null) => {
  const makesSelection = Array.isArray(nextValue) ? nextValue : [];
  searchValues.makes = [...makesSelection];
  searchStore.selectedInput.makes = [...makesSelection];
  await searchStore.searchCount();
  getUserMakesId();
};

const applyMobileModels = async (nextValue: any[] | any | null) => {
  const modelsSelection = Array.isArray(nextValue) ? nextValue : [];
  searchValues.models = [...modelsSelection];
  searchStore.selectedInput.models = [...modelsSelection];
  await searchStore.searchCount();
};

onBeforeMount(() => {
  if (searchStore.getMakes.length == 0) {
    searchStore.fetchMarks();
  }
});

const getUserMakesId = () => {
  try {
    if (searchStore.getUserMakesId.length != 0) {
      searchStore.fetchModels(searchStore.getUserMakesId);
    }
  } catch (error) {
    // console.log(error);
  }
};

const handleSearchInput = useDebounceFn(async ($event: any, inputType: string) => {
  const inputValue = $event.target.value;
  if (inputType === "maxPrice") {
    searchValues.maxPrice = inputValue || null;
    searchStore.getSelectedInput.maxPrice = inputValue || null;
  } else if (inputType === "maxKlm") {
    searchValues.maxKilometers = inputValue || null;
    searchStore.getSelectedInput.maxKilometers = inputValue || null;
  }

  await searchStore.searchCount();
}, 500);

const buildPromotedPayload = () => {
  let payload: Record<string, any> = {};
  const selectedMakes = Array.isArray(searchStore.userInput?.makes)
    ? searchStore.userInput.makes
    : [];
  const selectedModels = Array.isArray(searchStore.userInput?.models)
    ? searchStore.userInput.models
    : [];

  const makesIds = selectedMakes
    .map((make: any) => make?.id)
    .filter((id: any) => typeof id === "number");
  const modelsIds = selectedModels
    .map((model: any) => model?.id)
    .filter((id: any) => typeof id === "number");

  if (makesIds.length) payload.makesIds = makesIds;
  if (modelsIds.length) payload.modelsIds = modelsIds;

  payload = {
    ...payload,
    ...searchStore.filterUserSearchInput(searchStore.userInput),
  };

  return Object.fromEntries(
    Object.entries(payload).filter(([key, value]) => key !== "front" && value !== false)
  );
};

const fetchPromotedForCurrentSearch = async (options?: {
  resetOldPromotedIds?: boolean;
}) => {
  const payload = buildPromotedPayload();
  const limit = Object.keys(payload).length > 0 ? 10 : 2;
  const oldPromotedAnnouncementIds = options?.resetOldPromotedIds
    ? []
    : getDisplayedPromotedIds(
      searchStore.getPromotedSearchResult ?? [],
      searchStore.getFetchResult?.announcements ?? []
    );

  const response: any = await $fetch("/announcements/promoted-search-result", {
    method: "POST",
    headers: {
      token: runTimeConfig.public.token,
    },
    body: { ...payload, limit, oldPromotedAnnouncementIds, },
    baseURL: runTimeConfig.public.baseUrl,
  });

  const announcements = Array.isArray(response)
    ? response
    : response?.announcements ?? [];

  searchStore.setPromotedSearchResult(
    getUniquePromotedAnnouncements(announcements)
  );
};

const applySearch = async () => {
  const searchQuery = searchQuerys(searchValues, searchStore);
  searchStore.userInput = { ...searchStore.selectedInput };
  // Home -> filter: do not reuse home promoted IDs in next promoted request.
  searchStore.clearPromotedSearchResult();
  await fetchPromotedForCurrentSearch({ resetOldPromotedIds: true });
  await searchStore.fetchAnnounce(1, dashStore.getUserProfil.id);
  if (typeof searchStore.getFetchResult?.totalCount === "number") {
    searchStore.setAnnounceCount(searchStore.getFetchResult.totalCount);
  }
  await navigateTo(`/voitures?${searchQuery.toString()}`);
};

</script>